import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import Scheduler from "../../components/controls/scheduler/scheduler";
import JisDialogForm from "../../components/formdialog";
import Calendar from "../calendar";

function CaseScheduler() {
  const navigate = useNavigate();
  const { eventtype } = useParams();
  // const _sdate = moment(new Date(), "YYYY-MM-DD");
  const today = new Date();

  const _sdate = moment().month(today.getMonth()).date(today.getDate());

  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [schedules, setSchedules] = useState([]);
  const [startdate, setStartdate] = useState(_sdate.format("YYYY-MM-DD"));
  const [enddate, setEnddate] = useState(
    moment(_sdate).add(4, "days").format("YYYY-MM-DD")
  );
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [openCase, setOpenCase] = useState(false);
  const [active, setActive] = useState(null);
  const [isRe, setIsReschedule] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [sche, setSche] = useState({});
  const [now, setNow] = useState(moment());

  const onSchedules = () => {
    console.log(startdate);
    console.log(enddate);
    onLoad();
  };

  useEffect(() => {
    console.log(startdate, "START DATE");
    console.log(_sdate, "today");
    onLoad();
  }, []);
  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/shedules/${startdate}/${enddate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSchedules(data.schedules);
        const events = data.schedules.map((s) => {
          const start = moment(s.startTime, "HH:mm");
          const end = moment(s.endTime, "HH:mm");
          const duration = moment.duration(end.diff(start)).asHours();

          return {
            title: s.casedetails?.caseTitle || "Untitled",
            date: s.scheduleDate,
            scheduleId: s.id,
            caseId: s.caseId,
            startHour: start.hours() + start.minutes() / 60,
            duration,
            room: s.room ? `Room ${s.room}` : `Court ${s.courtId}`,
            time: `${start.format("h:mm A")} - ${end.format("h:mm A")}`,
          };
        });
        setSchedules(events);
        console.log(events);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onCardAction = (action) => {
    //navigate(`/case-details/${caseid}`)
    console.log(action);
    action.type = action.action;

    setActive(action.event);
    if (action.type == "details") {
      // setOpenCase(true);
      navigate(`/case-details/${action.event.caseId}`);
    } else if (action.type == "reschedule") {
      //this is for reschedule
      setIsReschedule(true);
    } else if (action.type == "proceed") {
      //navigate to hearing
      navigate(`/hearing/${action.event.scheduleId}`);
    } else if (action.type == "cancel") {
      //cancel
      setIsCancel(true);
    }
  };
  const onCloseOpenCase = () => {
    /* setActive(null);
    setIndex(-1); */
    setOpenCase(false);
  };
  const onScheduleChange = (e) => {
    setSche({ ...sche, [e.target.name]: e.target.value });
  };
  const onSave = async (e) => {
    e.preventDefault();

    setErr("");

    var obj = { ...sche, scheduleId: active.scheduleId, IsSchedule: isRe };
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/hearing/reschedule`, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        if (isRe) {
          setAlert({
            open: true,
            title: "Case Schedule",
            subtitle: " Cases scheduled successfully",
          });
          setIsReschedule(false);
        } else {
          setAlert({
            open: true,
            title: "Case Schedule",
            subtitle: " Cases cancelled",
          });
          setIsCancel(false);
        }

        onLoad();
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  return (
    <div>
      {/* <Scheduler
        startDate={startdate}
        endDate={enddate}
        onCardAction={onCardAction}
        events={schedules}
      /> */}
      <Calendar
        events={schedules}
        onEventClick={onCardAction}
        initialDate={now._d}
      />

      <BackLoader open={loading} />
      {openCase && active != null && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="caseinfo"
            />
          </div>
        </JisDialogForm>
      )}
      {isRe && (
        <JisDialogForm
          title="Re-Schedule"
          onClose={() => setIsReschedule(false)}
        >
          <div>
            <form className="calendar-reschedule-modal" onSubmit={onSave}>
              {isRe && (
                <div>
                  {" "}
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label>
                        {" "}
                        Schedule Date <span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        {/* <DynamicIcon iname="calendar_clock" /> */}
                        <input
                          name="scheduleDate"
                          type="date"
                          required
                          value={sche.scheduleDate}
                          onChange={onScheduleChange}
                          placeholder="Date"
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        {" "}
                        Start Time<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        {/* <DynamicIcon iname="acute" /> */}
                        <input
                          placeholder="Start Time"
                          type="time"
                          name="startTime"
                          required={true}
                          value={sche.startTime}
                          onChange={onScheduleChange}
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        {" "}
                        End Time<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        {/* <DynamicIcon iname="chronic" /> */}
                        <input
                          placeholder="Time"
                          type="time"
                          required={true}
                          name="endTime"
                          value={sche.endTime}
                          onChange={onScheduleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-group">
                    <label> Agenda</label>
                    <div className="input-wrapper">
                      <textarea
                        required={true}
                        name="agenda"
                        placeholder="Add Agenda"
                        value={sche.agenda}
                        onChange={onScheduleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="input-group">
                    <label> Comment</label>
                    <div className="input-wrapper">
                      <textarea
                        required={true}
                        name="comment"
                        placeholder="Add Comment"
                        value={sche.comment}
                        onChange={onScheduleChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
              )}

              <div className="calendar-button-group">
                <JisButton
                  variant="outline"
                  onClick={() => setIsReschedule(false)}
                >
                  Cancel
                </JisButton>
                <JisButton type="submit">Re-Schedule </JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}

      {isCancel && (
        <JisDialogForm title="Cancel" onClose={() => setIsCancel(false)}>
          <div>
            <form onSubmit={onSave}>
              <div>
                <p>This Hearing will be cancelled</p>
                <div className="input-group">
                  <label> Comment</label>
                  <div className="input-wrapper">
                    <textarea
                      required={true}
                      name="comment"
                      placeholder="comment"
                      value={sche.comment}
                      onChange={onScheduleChange}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div>
                <JisButton type="submit">Cancel Schedule</JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CaseScheduler;
